import * as Types from '../../constants/actionTypes';
import AuthAxios from '../../models/Axios'
import { LOCAL_URL, API_REQUESTS } from '../../helper/constant'



export const GET_CLIENT_TERMS = (payload) => (dispatch) => {
    const { portalId } = payload
    if (!portalId) {
        return
    }

    const CLIENT_URL = `${LOCAL_URL}${API_REQUESTS.GET_TERMS}/getTermsAndPrivacy`
    AuthAxios.axios.get(CLIENT_URL, { params: payload })
        .then((response) => {
            dispatch({
                type: Types.CLIENT_TERMS_SUCCESS,
                payload: response.data && response.data.data,
            })
            //toast.info("Terms of Use Added Successfully");
        })
        .catch(error => dispatch({ type: Types.CLIENT_TERMS_ERROR, payload: error }))
}

export const GET_DEFAULT_CULTURE = (payload) => async (dispatch) => {
    const { portalId } = payload
    if (!portalId) {
        return
    }
    try {
        const URL = `${LOCAL_URL}${API_REQUESTS.GET_TERMS}/getDefaultCulture`;
        const response = await AuthAxios.axios.get(URL, { params: payload });
        return response.data && response.data.data
    } catch (err) {
        dispatch({ type: Types.CLIENT_TERMS_ERROR, payload: err });
    }
}

export const GET_CULTURE_LIST = () => async (dispatch) => {
    try {
        const cultureList = `${LOCAL_URL}/cultures/getCulturesList`
        const response = await AuthAxios.axios.get(cultureList);
        return response?.data && response?.data?.data
    } catch (err) {
        dispatch({ type: Types.CLIENT_TERMS_ERROR, payload: err });
    }
}